export default __webpack_public_path__ + "e6636fce05c66fcaca4e7ae03316bef7.svg";